import breakpoint from '@carvana/helios-layout/breakpoint';
import { background, text } from '@carvana/helios-styles';
import body from '@carvana/helios-typography/body';
import heading from '@carvana/helios-typography/heading';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

export const Container = styled.div`
  background: ${background.default};
`;

export const Wrapper = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-template-areas: 'title' 'image' 'content';
  padding: 32px 0px 40px 0px;
  justify-content: center;

  ${breakpoint.sm`
    padding: 40px 0px;
    grid-template-areas: "title title"
    "content image";
    justify-content: space-between;
  `}

  ${breakpoint.md`
    padding: 64px 0px 56px 0;
    grid-template-areas: "title image"
    "content image";
    justify-content: space-between;
  `}
`;

export const Title = styled.div`
  ${heading['2Xl']};
  color: ${text.strong};
  margin-bottom: 40px;
  grid-area: title;

  ${breakpoint.sm`
    ${heading['2Xl']};
  `}

  ${breakpoint.md`
    ${heading['3Xl']};
  `}
`;

export const ContentWrapper = styled.div`
  grid-area: content;

  ${breakpoint.sm`
    margin-right: 32px;
  `}

  ${breakpoint.md`
    margin-right: 72px;
  `}
  ${breakpoint.lg`
    margin-right: 132px;
  `}
`;

export const FigurePart = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
  margin-right: 16px;

  ${breakpoint.sm`
    margin-right: 16px;
  `}

  ${breakpoint.md`
    margin-right: 24px;
  `}
`;

export const TextPart = styled.div`
  margin-bottom: 40px;
`;

type NumberProps = {
  left: string;
  right: string;
};

export const Number = styled.div<NumberProps>`
  ${heading.xl};
  color: ${text.primary};
  border: 2px solid ${text.primary};
  border-radius: 50%;
  padding: 14px ${props => props.right} 14px ${props => props.left};
`;

type LineProps = {
  height?: string;
};

export const Line = styled.div<LineProps>`
  height: 100%;
  border-left: 2px solid ${text.primary};
  margin-left: 30px;
`;

export const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  height: 327px;
  width: 327px;
  grid-area: image;
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;

  ${breakpoint.sm`
    width: 256px;
    height: 424px;
    margin-bottom: 0;
  `}

  ${breakpoint.md`
    height: 578px;
    width: 384px;
  `}

  ${breakpoint.xl`
    height: 578px;
    width: 578px;
  `}
`;

export const ImageStyle: CSSProperties = {
  objectFit: 'cover',
  objectPosition: 'top',
  borderRadius: '24px'
};

export const Section = styled.div`
  display: flex;
  flex-direction: row;
`;

export const SubTitle = styled.div`
  ${heading.md};
  color: ${text.strong};
  padding-top: 14px;
  padding-bottom: 8px;

  ${breakpoint.sm`
    ${heading.md};
  `}

  ${breakpoint.md`
    ${heading.lg};
  `}
`;

export const Description = styled.div`
  ${body.sm};
  color: ${text.default};

  ${breakpoint.sm`
    ${body.sm};
  `}

  ${breakpoint.md`
    ${body.md};
  `}
`;

export const ButtonWrapper = styled.a`
  margin: 0 auto;

  button {
    width: 100%;

    ${breakpoint.sm`
      width: 196px;
    `}
  }
`;
